import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import receipt from '@/components/receipt'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/receipt',
      name: 'receipt',
      component: receipt
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js


// WEBPACK FOOTER //
// ./src/router/index.js